import { streamingModels } from '@/mocks/streamingModels';

export default function StreamingSection() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100 overflow-hidden">
      {/* Subtle ambient glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-emerald-400/2 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-semibold mb-5">
            <i className="ri-broadcast-line text-xs"></i>
            Streaming
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 tracking-tight leading-[1.1]">
            Dos maneras de{' '}
            <span className="text-emerald-600">estar al aire</span>
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            Ya tengas tu propio streaming o necesites uno, RFW te da la solución. Simple. Sin letra chica.
          </p>
        </div>

        {/* Two models — side by side */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-5">
          {streamingModels.map((model) => (
            <div
              key={model.id}
              className={`relative flex flex-col rounded-2xl p-7 md:p-8 transition-all duration-300 ${
                model.highlighted
                  ? 'bg-background-50 border-2 border-emerald-400/50 shadow-lg shadow-emerald-500/5'
                  : 'bg-background-50 border border-background-200/50 hover:border-background-300/60'
              }`}
            >
              {/* Highlight badge */}
              {model.highlighted && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-emerald-500 text-white text-xs font-bold whitespace-nowrap">
                  Recomendado
                </div>
              )}

              {/* Icon */}
              <div className={`w-14 h-14 flex items-center justify-center rounded-2xl mb-5 transition-all duration-300 ${
                model.highlighted
                  ? 'bg-emerald-500 text-white'
                  : 'bg-emerald-50 text-emerald-600'
              }`}>
                <i className={`${model.icon} text-xl`}></i>
              </div>

              {/* Title */}
              <h3 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2">
                {model.title}
              </h3>

              {/* Subtitle */}
              <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                {model.subtitle}
              </p>

              {/* Features */}
              <ul className="flex-1 space-y-3 mb-7">
                {model.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <div className={`w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full mt-0.5 ${
                      model.highlighted
                        ? 'bg-emerald-100 text-emerald-600'
                        : 'bg-emerald-50 text-emerald-500'
                    }`}>
                      <i className="ri-check-line text-[10px]"></i>
                    </div>
                    <span className="text-sm text-foreground-600 leading-relaxed">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA */}
              <a
                href={model.ctaUrl}
                className={`inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-sm font-bold whitespace-nowrap transition-all cursor-pointer ${
                  model.highlighted
                    ? 'bg-emerald-500 text-white hover:bg-emerald-600 shadow-lg shadow-emerald-500/20'
                    : 'bg-emerald-50 text-emerald-700 hover:bg-emerald-100'
                }`}
              >
                {model.ctaLabel}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>

        {/* Bottom reassurance */}
        <div className="mt-12 text-center">
          <p className="text-xs text-foreground-400">
            Sin contratos forzosos. Sin cargos ocultos. Solo tu música al aire.
          </p>
        </div>
      </div>
    </section>
  );
}